/**
 * Tom ersättare för re2js.
 *
 * Firestore-SDK:n importerar re2js ovillkorligt för att kunna köra
 * `regexMatch` och `regexContains` i Firestore Pipelines. Biblioteket är en
 * portad reguljäruttrycksmotor på 42 kB gzip som hamnar i huvudpaketet och
 * laddas av varje besökare – även den som bara ska visa upp en rabatt i
 * kassan.
 *
 * Lirahäftet använder inte Pipelines någonstans; all läsning går via vanliga
 * `query()`-anrop. Aliaset i vite.config.ts pekar hit i stället, och kastet
 * nedan gör att det märks direkt om någon i framtiden ändå tar in Pipelines,
 * i stället för att felet dyker upp som något obegripligt i produktion.
 */

const MESSAGE =
  're2js är medvetet bortplockat ur bygget (se src/stubs/re2js.ts). ' +
  'Firestore Pipelines med regexMatch/regexContains går därför inte att ' +
  'använda. Ta bort aliaset i vite.config.ts om de ska börja användas.'

export const RE2JS = {
  compile(): never {
    throw new Error(MESSAGE)
  },
  matches(): never {
    throw new Error(MESSAGE)
  },
  quote(): never {
    throw new Error(MESSAGE)
  },
}

export default { RE2JS }
